module.exports = __webpack_public_path__ + "static/media/backWave6.9012f192.svg";